function requestPassword(pwdProtected, pwd){
    const maxTries = 3;
    if (pwdProtected=="on" && !window.inPreviewMode)
    {
        var pwdInput = prompt(trans('password.0'));
        if (pwdInput != pwd || pwdInput =="na") {
            for(var tries = 1; tries < maxTries; tries++){
                pwdInput = prompt("Wrong password, please try again:");
                if(pwdInput == pwd){
                    return;
                }
            }
            
        }
        else{
            return;
        }
        window.location.href = "/";
    }   
}